define('lq/navigatorSpa',[
    'lq',
    './navigationHistory'
], function (lq, NavigationHistory) {
    'use strict';
    
    var NavigatorSpa = function (initialActionId, url, history, onNavigate, onNavigationStarting) {
        this.currentActionId = initialActionId;
        this.url = url;
        this.onNavigate = onNavigate;
        this.onNavigationStarting = onNavigationStarting;
        this.history = history;
    };

    NavigatorSpa.withLocalStorage = function (initialActionId, url, onNavigate, onNavigationStarting) {
        return new NavigatorSpa(initialActionId, url, NavigationHistory.withLocalStorage('spa'), onNavigate, onNavigationStarting);
    };

    NavigatorSpa.inMemory = function (initialActionId, url, onNavigate) {
        return new NavigatorSpa(initialActionId, url, NavigationHistory.inMemory('spa'), onNavigate);
    };

    NavigatorSpa.prototype.openAction = function (actionId, globals, locals, openBlank) {
        if (openBlank) {
            var url = lq.getTenantUrl('LicquidAction/Get/' + actionId);
            var parameters = {};
            if (_.keys(globals).length)
                parameters.globals = JSON.stringify(globals);
            if (_.keys(locals).length)
                parameters.parameters = JSON.stringify(locals);
            var targetUrl = this.url.prepare(url, parameters);
            this.url.openUrl(targetUrl, openBlank);
        } else {
            this.history.push(this.currentActionId);
            this.currentActionId = actionId;

            this.onNavigate(actionId, globals, locals);
        }
    };

    // a redirect announces its navigation before it updates the navigation trail (it opens the action after that)
    NavigatorSpa.prototype.navigationStarting = function () {
        if (this.onNavigationStarting) this.onNavigationStarting();
    };

    NavigatorSpa.prototype.getPreviousId = function () {
        return this.history.peek();
    };
    
    NavigatorSpa.prototype.goToPrevious = function (globals, locals) {
        var previousActionId = this.history.pop();
        if (!previousActionId) return;

        this.currentActionId = previousActionId;
        this.onNavigate(previousActionId, globals, locals);
    };

    return NavigatorSpa;
});
